// 88吃瓜后续专区 —— 单页站点结构与通用文案数据
// 内容为娱乐热点事件后续的客观梳理与转述，均基于公开信息整理，事件细节以官方与当事人说法为准。

export const siteNav = [
  { label: '首页', href: '#top' },
  { label: '最新进展', href: '#latest' },
  { label: '续集新料', href: '#feed' },
  { label: '时间线', href: '#timeline' },
  { label: '热评', href: '#talk' },
  { label: '常见问题', href: '#faq' },
  { label: '关于本站', href: '#about' },
];

export const heroStats = [
  { value: '30+', label: '累计跟进更新' },
  { value: '12', label: '时间线关键节点' },
  { value: '6', label: '事件走向板块' },
  { value: '1.8w', label: '蹲后续网友' },
];

export const hotTags = ['当事人回应', '续集爆料', '新线索', '事件反转', '平台动态', '时间线梳理'];

export const aboutPoints = [
  {
    icon: 'ri-eye-line',
    title: '专注后续',
    desc: '不炒冷饭。正片结束后仍持续追踪当事人回应、续集爆料与暗涌线索，帮你在信息洪流里抓住真实走向。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '时间线梳理',
    desc: '把零散片段按时间线重新排好，反转前因后果一目了然，新来的网友也能快速补课。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '求证优先',
    desc: '对每一条新料标注来源与可信度，区分「实锤」「网友分析」「待验证」，不对事件轻易下定论。',
  },
  {
    icon: 'ri-team-line',
    title: '蹲后续社区',
    desc: '这里是共同追瓜的讨论场。评论区互相补充线索、指正误读，让每一段续集都有来有回。',
  },
];

export const siteCredo = [
  '本站定位于娱乐热点的客观信息梳理与转述，不站队、不造谣、不引导网络对立。',
  '内容均基于公开平台信息整理并标注来源与可信度，事件最终以官方通报与当事人本人说法为准。',
  '反对人肉搜索、隐私泄露与网络暴力，评论区发言请基于事实、保持克制与尊重。',
  '若您为事件当事人或版权方，认为相关信息存在不实，欢迎通过下方订阅或投稿通道联系我们，我们将尽快核实处理。',
];

export const hotComments = [
  {
    name: '蹲到天荒地老',
    level: '潜水吃瓜员',
    time: '12 分钟前',
    like: 326,
    text: '正片结束我以为结束了，结果蹲到凌晨三点还在刷，这后续比正片还精彩，剧组没白等。',
  },
  {
    name: '今天也在等更新',
    level: '铁杆蹲友',
    time: '38 分钟前',
    like: 289,
    text: '提醒大家理性点，好多「锤」其实都是网友拼图，先别急着定性，等本人回应再说。',
  },
  {
    name: '一只路过的猹',
    level: '吃瓜路人',
    time: '1 小时前',
    like: 198,
    text: '时间线那篇整理得太清楚了，不然我这种断网一周的人根本不知道前因后果，收藏了。',
  },
  {
    name: '瓜田里的猹',
    level: '潜水吃瓜员',
    time: '2 小时前',
    like: 167,
    text: '又反转了？我瓜子刚买好，这届剧情真是层层套娃，蹲后续的速度赶不上更新的速度。',
  },
  {
    name: '认真吃瓜人',
    level: '铁杆蹲友',
    time: '3 小时前',
    like: 144,
    text: '评论区还是要注意，别去给当事人私信刷屏，吃瓜可以，别越界。理性追更。',
  },
];

export const faqItems = [
  {
    q: '「88吃瓜后续」到底在追什么？',
    a: '88吃瓜后续专区主要聚焦一则近期引发广泛讨论的网络热点事件的后续进展，包括当事各方的回应、续集爆料、新线索与事件走向更新。我们不以「吃瓜结论」为卖点，而是把散落在各平台的信息按时间线重排，方便网友快速了解整件事的最新状态与来龙去脉。',
  },
  {
    q: '这里的「后续」「续集」内容来源可靠吗？',
    a: '每条跟进都会标注来源与可信度，分为「当事人/官方回应」「平台信息」「网友分析」「待验证传闻」几档。涉及对当事人有影响的信息，我们一律以官方通报与本人公开说法为准，并对未经证实的片段进行明确标注，建议您多方核对后再判断。',
  },
  {
    q: '事件如果出现新反转，我会第一时间看到吗？',
    a: '会。最新进展板块与续集新料列表按时间倒序排列，一旦出现当事人回应、关键新线索或剧情反转，我们会尽快整理更新，并同步在话题时间线中追加新节点。您也可以通过页面底部的订阅提醒，把邮箱留给我们，新料更新时会及时通知。',
  },
  {
    q: '我是刚来蹲后续的新人，看不懂来龙去脉怎么办？',
    a: '建议先看「时间线」板块，我们把事件从爆出到发酵、再到现阶段的所有关键节点按顺序梳理好了，大约几分钟即可补齐前情。之后再进入续集新料板块跟进最新进展，就不会「断片」了。',
  },
  {
    q: '留言讨论有什么要注意的吗？',
    a: '本站主张理性吃瓜：基于事实发言、不传播未经证实的私密信息、不人肉搜索、不攻击当事人及其家人。涉及隐私与人身攻击的内容会被折叠处理。如果您在评论区发现其他用户的线索，也欢迎理性补充与指正。',
  },
  {
    q: '事件结束了，专区还会继续更新吗？',
    a: '如果事件在相当长一段时间内没有新进展且当事人已明确回应，我们会把专区调整为「已告一段落」状态，保留完整时间线与历史梳理供回看；若后续出现新的续集或反转，我们会在第一时间重新开启更新。',
  },
];